import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import img from "../assets/img/Privacybg.png";
import Banner from "../assets/img/Banner.svg";
import { privacyRoute } from "../utils/routes";
import { Audio, Oval, Rings } from "react-loader-spinner";
import parse from "html-react-parser";

function Privacy() {
  const location = useLocation();
  const [privacy, setPrivacy] = useState({});
  const [condition, setCondition] = useState({});
  const [policy, setPolicy] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    var pageId = {
      id: 6,
    };

    const getUserRequestDTO = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(pageId),
    };

    fetch(privacyRoute, getUserRequestDTO)
      .then((response) => response.json())

      .then((data) => {
        setLoading(false);
        var privacyContent = JSON.parse(data.msg.privacy_policy_information);

        var conditionContent = JSON.parse(
          data.msg.terms_and_condition_information,
        );

        setPrivacy({ privacyContent });
        setCondition({ conditionContent });
      });
  }, []);

  useEffect(() => {
    if (location.pathname === "/privacy-policy") {
      setPolicy(true);
    } else {
      setPolicy(false);
    }
  }, [location]);

  const changeState = (e) => {
    if (e.target.id == "privacy" || location.pathname === "/privacy-policy") {
      setPolicy(true);
    } else if (
      e.target.id == "condition" ||
      location.pathname === "/terms-and-condition"
    ) {
      setPolicy(false);
    }
  };
  return (
    <div className="displayWeb">
      <div className={loading === true ? "overlay" : " "}>
        <p id="loading">
          {loading ? <Rings color="#91298c" height={160} width={160} /> : null}
        </p>
      </div>
      <section className="privacy__top__navbar">
        <div className="container mb-0 mb-md-5">
          <div
            className="d-flex align-items-center justify-content-center privacy__top__navbar-inner"
            style={{
              background: `url(${Banner}) center center no-repeat`,
              backgroundSize: "contain",
              minHeight: "200px",
            }}
          >
            {policy == true ? (
              <>
                <h2 id="pageHeading" className="privacy__banner_heading">
                  Privacy Policy
                </h2>
              </>
            ) : policy == false ? (
              <>
                <h2 id="pageHeading" className="privacy__banner_heading">
                  Terms & Conditions
                </h2>
              </>
            ) : null}
          </div>
        </div>
      </section>

      <section className="privacy__top__navbar">
        <div className="container mt-md-5">
          {policy == true ? (
            <div className="privacy-terms-wrapper">
              {privacy?.privacyContent?.map((obj, index) => {
                return (
                  <div key={index}>
                    {index === 0 ? (
                      <>
                        <div className="">
                          <div className="col-lg-3 col-md-4 order-first order-md-last privacy">
                            <p className="text-end charges-date 0">
                              Updated On: Feb 01,2023
                            </p>
                            <Link to="/privacy-policy">
                              <h6
                                id="privacy"
                                onClick={(e) => changeState(e)}
                                className="privacy__cards privacy__cards__line "
                              >
                                Privacy Policy
                              </h6>
                            </Link>
                            <Link to="/terms-and-conditions">
                              <h6
                                id="condition"
                                onClick={changeState}
                                className="privacy__cards"
                              >
                                Terms & Conditions
                              </h6>
                            </Link>
                          </div>
                          <div className="col-lg-9 col-md-8">
                            <h4 style={{ display: "inline", color: "white" }}>
                              {obj.orderNum}
                            </h4>
                            &nbsp;
                            <h4 style={{ color: "white", display: "inline" }}>
                              {obj.heading}
                            </h4>
                            <p className="pt-2">{parse(obj.desc)}</p>
                          </div>
                        </div>
                      </>
                    ) : null}

                    {index >= 1 ? (
                      <>
                        <div className="row">
                          <div className="col-md-12">
                            <h4 style={{ display: "inline", color: "white" }}>
                              {obj.orderNum}
                            </h4>
                            &nbsp;
                            <h4 style={{ color: "white", display: "inline" }}>
                              {obj.heading}
                            </h4>
                            <p className="pt-2">{parse(obj.desc)}</p>
                          </div>
                        </div>
                      </>
                    ) : null}
                  </div>
                );
              })}
            </div>
          ) : policy == false ? (
            <div className="privacy-terms-wrapper">
              {condition?.conditionContent?.map((obj, index) => {
                return (
                  <div key={index}>
                    {index === 0 ? (
                      <>
                        <div className="">
                          <div className="col-lg-3 col-md-4 order-first order-md-last privacy">
                            <p className="text-end charges-date 0">
                              Updated On: Feb 01,2023
                            </p>
                            <Link to="/privacy-policy">
                              <h6
                                id="privacy"
                                onClick={(e) => changeState(e)}
                                className="privacy__cards"
                              >
                                Privacy Policy
                              </h6>
                            </Link>
                            <Link to="/terms-and-conditions">
                              <h6
                                id="condition"
                                onClick={changeState}
                                className="privacy__cards privacy__cards__line"
                              >
                                Terms & Conditions
                              </h6>
                            </Link>
                          </div>
                          <div className="col-lg-9 col-md-8">
                            <h4 style={{ display: "inline", color: "white" }}>
                              {obj.orderNum}.
                            </h4>
                            &nbsp;
                            <h4 style={{ color: "white", display: "inline" }}>
                              {obj.heading}
                            </h4>
                            <p className="pt-2">{parse(obj.desc)}</p>
                          </div>
                        </div>
                      </>
                    ) : null}

                    {index >= 1 ? (
                      <>
                        <div className="row">
                          <div className="col-md-12">
                            <h4 style={{ display: "inline", color: "white" }}>
                              {obj.orderNum}
                            </h4>
                            &nbsp;
                            <h4 style={{ color: "white", display: "inline" }}>
                              {obj.heading}
                            </h4>
                            <p className="pt-2">{parse(obj.desc)}</p>
                          </div>
                        </div>
                      </>
                    ) : null}
                  </div>
                );
              })}
            </div>
          ) : null}
        </div>
      </section>

      <div className="main" id="section"></div>
    </div>
  );
}

export default Privacy;
